{
  "schemaVersion": "1.0",
  "status": "DRAFT_DIRECTIONAL",
  "note": "Directional marketing content. Prices are management targets; public-pricing.json must be generated from Pricing Master at publish.",
  "moduleId": "intelligence",
  "features": [
    {
      "id": "ask-ai",
      "name": "Ask AI",
      "summary": "One entry point for maintenance questions.",
      "availability": "AVAILABLE"
    },
    {
      "id": "human-iq",
      "name": "humanIQ",
      "summary": "Capture and reuse expert knowledge.",
      "availability": "AVAILABLE"
    },
    {
      "id": "faa-iq",
      "name": "faaIQ",
      "summary": "Regulations, Advisory Circulars, and AD lookup.",
      "availability": "AVAILABLE"
    },
    {
      "id": "troubleshooting-iq",
      "name": "troubleshootingIQ",
      "summary": "Symptom-led investigation.",
      "availability": "AVAILABLE"
    },
    {
      "id": "parts-iq",
      "name": "partsIQ",
      "summary": "Part lookup, alternates, and sourcing.",
      "availability": "AVAILABLE"
    },
    {
      "id": "knowledge-curation",
      "name": "Knowledge Curation",
      "summary": "Review and approve organizational knowledge.",
      "availability": "AVAILABLE"
    },
    {
      "id": "document-intelligence",
      "name": "Document Intelligence",
      "summary": "Ingest manuals, procedures, and training content.",
      "availability": "AVAILABLE"
    }
  ]
}